import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { petpoojaService } from '../../../services/petpoojaService';

// Async thunk to fetch Petpooja menu
export const fetchPetpoojaMenu = createAsyncThunk(
  'petpooja/fetchPetpoojaMenu',
  async (restID, { rejectWithValue }) => {
    try {
      const data = await petpoojaService.getPetpoojaMenu(restID);
      return { restID, data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch Petpooja menu');
    }
  }
);

const initialState = {
  petpoojaMenus: {}, // Store menus by restaurant ID
  loading: false,
  error: null
};

const petpoojaSlice = createSlice({
  name: 'petpooja',
  initialState,
  reducers: {
    clearPetpoojaError: (state) => {
      state.error = null;
    },
    clearPetpoojaMenu: (state, action) => {
      const restID = action.payload;
      delete state.petpoojaMenus[restID];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPetpoojaMenu.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPetpoojaMenu.fulfilled, (state, action) => {
        state.loading = false;
        const { restID, data } = action.payload;
        state.petpoojaMenus[restID] = data;
      })
      .addCase(fetchPetpoojaMenu.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearPetpoojaError, clearPetpoojaMenu } = petpoojaSlice.actions;
export default petpoojaSlice.reducer;